import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import { withTranslation } from 'react-i18next';
import TableHelper from 'src/utils/table-helper';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import { ButtonColors } from 'src/utils/constants';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { Entities } from 'src/common';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { formatMinutes } from 'src/components/misc/redux-form-helpers';
import { dateTimeFormatter } from 'src/utils/formatters';

class AdminOperatorSupportBillingTaskList extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
    }

    openConfirmDeleteDialog(item) {
        const { t } = this.props;
        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: item,
                onProceedDialog: this.onProceedDeleteSupportTask,
                bodyText: t('invoice.confirm_delete'),
                proceedText: t('user_functionality.delete'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.DANGER,
            },
            title: item.supportTaskDescription,
            noButtons: true,
        });
    }

    onProceedDeleteSupportTask(item) {
        this.props.deleteById(item.id, Entities.OPERATOR_SUPPORT_BILLING, 0);
    }

    tableActionsFormatter(cell, item) {
        const { selectedMonth } = this.props;
        const isBillingMonth = moment.unix(selectedMonth).month() === moment().startOf('month').month();
        return (
            <div>
                <button
                    type="button"
                    className={`btn btn-xs transparent ${!isBillingMonth ? 'disabled' : ''}`}
                    onClick={() => {
                        if (isBillingMonth) this.openConfirmDeleteDialog(item);
                    }}>
                    <span className="glyphicon glyphicon glyphicon-trash text-danger" />
                </button>
            </div>
        );
    }

    render() {
        const { operatorSupportBillingItems, t } = this.props;
        const tableData = [];

        if (operatorSupportBillingItems.items.length > 0) {
            operatorSupportBillingItems.items.map(item => {
                tableData.push({
                    id: item.id,
                    supportTaskDescription: item.supportTaskDescription,
                    supportStarted: dateTimeFormatter(item.supportStarted),
                    supportEnded: dateTimeFormatter(item.supportEnded),
                    duration: formatMinutes(
                        t,
                        moment.duration(moment(item.supportEnded).diff(moment(item.supportStarted))).asMinutes(),
                    ),
                });
            });
        }

        if (tableData.length < 0 && !operatorSupportBillingItems.isFetching) return <div>Hello</div>;
        else
            return (
                <BootstrapTableErrorBoundary>
                    <BootstrapTable data={tableData}>
                        <TableHeaderColumn columnTitle={false} hidden={true} isKey={true} dataField="id">
                            {t('invoice.actions')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="supportTaskDescription">
                            {t('invoice.description')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="supportStarted">
                            {t('invoice.startedAt')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="supportEnded">
                            {t('invoice.endedAt')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="duration">
                            {t('invoice.duration')}
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="actions" width="90" dataFormat={this.tableActionsFormatter}>
                            {t('common_phrases.actions')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            );
    }
}

export default withTranslation()(composeModalActions(AdminOperatorSupportBillingTaskList));
